import React, { useState, cloneElement, useCallback } from 'react';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import { connect } from 'react-redux';
import flowRight from 'lodash.flowright';

import withUserCheck from '../../../utils/withUserCheck';
import { translate } from '../../../i18n/I18nProvider';
import { isUndefined } from '../../../utils/isDefined';
import { setRange } from '../../../modals/editRange/actions/setRange';

const ConnectRangesMoreActionsMenu = ({
  children,
  numberRange,
  resetValues,
  setRange
}) => {
  const [anchorEl, setAnchorEl] = useState(null);

  const handleClick = event => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const onEditClick = useCallback(
    () => {
      handleClose();
      return setRange({ range: numberRange, resetValues });
    },
    // eslint-disable-next-line
    [numberRange]
  );

  const onAddClick = useCallback(
    () => {
      handleClose();
      return setRange({ range: {}, resetValues, isEdit: false });
    },
    // eslint-disable-next-line
    [numberRange]
  );

  return (
    <div>
      {cloneElement(children, { onClick: handleClick })}
      <Menu
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}
        getContentAnchorEl={null}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
        transformOrigin={{ vertical: 'top', horizontal: 'center' }}
      >
        <MenuItem disabled={isUndefined(numberRange)} onClick={onEditClick}>
          {translate('TOOLTIP.EDIT_RANGE')}
        </MenuItem>
        <MenuItem onClick={onAddClick}>{translate('EDIT_RANGE.ADD')}</MenuItem>
      </Menu>
    </div>
  );
};

const mapDispatchToProps = {
  setRange
};

export default flowRight(
  withUserCheck,
  connect(null, mapDispatchToProps)
)(ConnectRangesMoreActionsMenu);
